import instance from "../../utils/axios";

const toFormData = (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) =>
    formData.append(key, val ?? "")
  );
  return formData;
};

// SAVE
export const saveBulletinVideo = async (payload) => {
  const response = await instance.post(
    "/churches/weeklybulliten/bullitenvideos/save",
    toFormData(payload)
  );
  return response.data;
};

// UPDATE
export const updateBulletinVideo = async (payload) => {
  const response = await instance.post(
    "/churches/weeklybulliten/bullitenvideos/update",
    toFormData(payload)
  );
  return response.data;
};

// DELETE
export const deleteBulletinVideo = async (payload) => {
  const response = await instance.post(
    "/churches/weeklybulliten/bullitenvideos/delete",
    toFormData(payload)
  );
  return response.data;
};

// READ
export const readBulletinVideos = async (payload) => {
  const response = await instance.post(
    "/churches/weeklybulliten/bullitenvideos/read",
    toFormData(payload)
  );
  return response.data;
};
